export interface ListFilter {
  search: string;
  page?: number;
  size?: number;
  sort: string;
  direction: 'asc' | 'desc';
}
